export const marketStatus = {
    stocks: -15,
    realEstate: -5,
    crypto: -20,
    business: -10
};
  
